import skillsTagColoredDark from "../../../../src/pages/rovo-ui/skills-tag/_assets/skills-tag-colored-dark.png";
import skillsTagColoredLight from "../../../../src/pages/rovo-ui/skills-tag/_assets/skills-tag-colored-light.png";
import skillsTagNeutralDark from "../../../../src/pages/rovo-ui/skills-tag/_assets/skills-tag-neutral-dark.png";
import skillsTagNeutralLight from "../../../../src/pages/rovo-ui/skills-tag/_assets/skills-tag-neutral-light.png";
import skillsTagPartsDark from "../../../../src/pages/rovo-ui/skills-tag/_assets/skills-tag-parts-dark.png";
import skillsTagPartsLight from "../../../../src/pages/rovo-ui/skills-tag/_assets/skills-tag-parts-light.png";
import * as React from 'react';
export default {
  skillsTagColoredDark,
  skillsTagColoredLight,
  skillsTagNeutralDark,
  skillsTagNeutralLight,
  skillsTagPartsDark,
  skillsTagPartsLight,
  React
};